export default __webpack_public_path__ + "static/media/dragoge.edbfbe24.mp4";